/**
 * @generated SignedSource<<815ebce93b7bc42a7071dbca5a043bc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralsQmeeQuery$variables = {};
export type ReferralsQmeeQuery$data = {
  readonly referralHistory: {
    readonly " $fragmentSpreads": FragmentRefs<"LifetimeReferralsStats_referralsRef_qmee" | "ReferralsMetrics_referralsRef">;
  };
  readonly walletBalance: {
    readonly amount: {
      readonly currency: string;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ReferAFriend_referralsRef_qmee">;
};
export type ReferralsQmeeQuery = {
  response: ReferralsQmeeQuery$data;
  variables: ReferralsQmeeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "CurrencyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferralsQmeeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralHistory",
        "kind": "LinkedField",
        "name": "referralHistory",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReferralsMetrics_referralsRef"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LifetimeReferralsStats_referralsRef_qmee"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ReferAFriend_referralsRef_qmee"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReferralsQmeeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralHistory",
        "kind": "LinkedField",
        "name": "referralHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReferralsStats",
            "kind": "LinkedField",
            "name": "lifetime",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "successes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pending",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyAmount",
                "kind": "LinkedField",
                "name": "earnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subUnitAmount",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralLink",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe1923982cab5235e69ee9b7e234420e",
    "id": null,
    "metadata": {},
    "name": "ReferralsQmeeQuery",
    "operationKind": "query",
    "text": "query ReferralsQmeeQuery {\n  referralHistory {\n    ...ReferralsMetrics_referralsRef\n    ...LifetimeReferralsStats_referralsRef_qmee\n  }\n  walletBalance {\n    amount {\n      currency\n    }\n    id\n  }\n  ...ReferAFriend_referralsRef_qmee\n}\n\nfragment LifetimeReferralsStats_referralsRef_qmee on ReferralHistory {\n  lifetime {\n    successes\n    earnings {\n      subUnitAmount\n      currency\n    }\n  }\n}\n\nfragment ReferAFriend_referralsRef_qmee on Query {\n  referralHistory {\n    lifetime {\n      successes\n      earnings {\n        subUnitAmount\n        currency\n      }\n    }\n  }\n  referralLink\n}\n\nfragment ReferralsMetrics_referralsRef on ReferralHistory {\n  lifetime {\n    successes\n    pending\n  }\n}\n"
  }
};
})();

(node as any).hash = "081d84772a414d6d1f95b46b66128557";

export default node;
